import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-modal",
  "use": "vab-icon-modal-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-modal\">\n<path d=\"M19 9H21V17C21 18.1 20.1 19 19 19H5C3.9 19 3 18.1 3 17V7C3 5.9 3.9 5 5 5H17V7H5V17H19V9ZM17 9H7V11H17V9ZM15 13H7V15H15V13ZM19 7H21V5H19V7Z\" fill=\"#09244B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol